<form class="form" [formGroup]="invoiceForm" (ngSubmit)="submit()">
  <div id="dialog-add-invoices-container">
    <!-- Form -->
    <div id="form">
      <!-- Origen de la factura -->
      <div class="item-form" *ngIf="showOriginStep">
        <p class="caption-01-semi-bold grey-700">Origen de la factura</p>
        <qr-dropdown
          [config]="this.dropdownOrigin"
          [selected]="this.invoiceForm.value.origin"
          (change)="dropdownOriginChange($event)"
        ></qr-dropdown>
      </div>
      <!-- Cliente -->
      <div class="item-form" *ngIf="showClientStep">
        <p class="caption-01-semi-bold grey-700">
          {{
            this.invoiceForm.value.origin != this.AGENT_OFFICE
              ? "Cliente"
              : "Punta"
          }}
        </p>
        <qr-toggle
          [config]="clientToggle"
          (change)="onChangeClient($event)"
          [isDisabled]="this.isClientDisabled"
        ></qr-toggle>
      </div>
      <!-- Agente -->
      <div class="item-form" *ngIf="showAgentStep">
        <p class="caption-01-semi-bold grey-700">Agente</p>
        <qr-dropdown
          [config]="this.dropdownAgent"
          [selected]="this.invoiceForm.value.agent"
          (change)="dropdownAgentChange($event)"
        ></qr-dropdown>
      </div>
      <ng-container *ngIf="showDetailsStep">
      <div class="item-double">
        <!-- Tipo de factura -->
        <div class="item-form item-left">
          <p class="caption-01-semi-bold grey-700">Tipo de factura</p>
          <qr-dropdown
            [config]="this.dropdownInvoicesType"
            [selected]="this.invoiceForm.value.invoiceType"
            (change)="dropdownInvoicesTypeChange($event)"
            [isDisabled]="this.dropdownInvoicesType.options.length == 0"
            (blurChange)="this.invoiceForm.get('invoiceType')?.markAsTouched()"
            [hasError]="
              invoiceForm.get('invoiceType')?.touched &&
              invoiceForm.get('invoiceType')?.invalid
            "
          ></qr-dropdown>
        </div>
        <!-- Numero de factura -->
        <div class="item-form item-right">
          <p class="caption-01-semi-bold grey-700">Número de factura</p>
          <qr-input
            class="input-autocomplete"
            [config]="inputInvoiceNumber"
            [value]="this.invoiceForm.value.number"
            (valueChange)="changeInputInvoiceNumber($event)"
            (blurChange)="this.invoiceForm.get('number')?.markAsTouched()"
            [hasError]="
              invoiceForm.get('number')?.touched &&
              invoiceForm.get('number')?.invalid
            "
          ></qr-input>
        </div>
      </div>
      <!-- Razon social -->
      <div
        class="item-form"
        *ngIf="this.invoiceForm.value.origin != AGENT_OFFICE"
      >
        <p class="caption-01-semi-bold grey-700">Razón social</p>
        <qr-input
          class="input-autocomplete"
          [config]="inputRazonSocial"
          [value]="this.invoiceForm.value.name"
          (valueChange)="changeInputRazonSocial($event)"
          (blurChange)="this.invoiceForm.get('name')?.markAsTouched()"
          [hasError]="
            invoiceForm.get('name')?.touched && invoiceForm.get('name')?.invalid
          "
        ></qr-input>
      </div>
      <!-- Concepto -->
      <div
        class="item-form"
        *ngIf="this.invoiceForm.value.origin != AGENT_OFFICE"
      >
        <p class="caption-01-semi-bold grey-700">Concepto</p>
        <qr-input
          class="input-autocomplete"
          [config]="inputInvoiceDescription"
          [value]="this.invoiceForm.value.description"
          (valueChange)="changeInputInvoiceDescription($event)"
          (blurChange)="this.invoiceForm.get('description')?.markAsTouched()"
          [hasError]="
            invoiceForm.get('description')?.touched &&
            invoiceForm.get('description')?.invalid
          "
        ></qr-input>
      </div>
        <div class="item-double">
          <!-- Moneda -->
          <div class="item-form item-left">
            <p class="caption-01-semi-bold grey-700">Monto</p>
            <qr-toggle
              [config]="currencyToggle"
              (change)="onChangeCurrency($event)"
            ></qr-toggle>
          </div>
          <!-- Monto -->
          <div class="item-form item-right">
            <p class="caption-01-semi-bold grey-700">&nbsp;</p>
            <qr-input
              class="input-autocomplete"
              [config]="inputAmount"
              [value]="
                this.invoiceForm.value.amount != null
                  ? (this.invoiceForm.value.amount | number : '1.0-2') || ''
                  : ''
              "
              (valueChange)="changeInputAmount($event, this.invoiceForm.value.id)"
              (keydown)="isValidDecimalNumber($event)"
              (blurChange)="this.invoiceForm.get('amount')?.markAsTouched()"
              [hasError]="!!inputAmount.errorMsg"
            ></qr-input>
          </div>
        </div>

        <!-- IVA -->
        <div class="item-double">
          <!-- Moneda -->
          <div class="item-form item-left">
            <p
              *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
              class="caption-01-semi-bold grey-700"
            >
              IVA
            </p>
            <p *ifNodeShow="[NODE_DO]" class="caption-01-semi-bold grey-700">
              ITBIS
            </p>

            <qr-toggle
              [config]="toggleIvaCurrency"
              (change)="onChangeIVACurrency($event)"
            ></qr-toggle>
          </div>
          <!-- Monto IVA -->
          <div class="item-form item-right">
            <p class="caption-01-semi-bold grey-700">&nbsp;</p>
            <qr-input
              class="input-autocomplete"
              [config]="inputIvaAmount"
              [value]="
                this.invoiceForm.value.iva != null
                  ? (this.invoiceForm.value.iva | number : '1.0-2') || ''
                  : ''
              "
              (valueChange)="changeInputIVA($event)"
              (keydown)="isValidDecimalNumber($event)"
              (blurChange)="this.invoiceForm.get('iva')?.markAsTouched()"
              [hasError]="
                invoiceForm.get('iva')?.touched &&
                invoiceForm.get('iva')?.invalid &&
                invoiceForm.value.iva != null
              "
            ></qr-input>
          </div>
        </div>
      <div
        class="item-double space-between"
        *ngIf="
          (this.invoiceForm.value.origin == OFFICE_CLIENT ||
            this.invoiceForm.value.origin == AGENT_OFFICE) &&
            this.overBilled > 0;
          else isoverbilled
        "
      >
        <p class="caption-01-semi-bold grey-700">Sobrefacturado</p>
        <p class="caption-01-semi-bold grey-700">
          {{ this.invoiceForm.value.amountCurrency == "U$S" ? "U$S" : "$" }}
          {{ this.overBilled | number : "1.0-2" }}
        </p>
      </div>
      <ng-template #isoverbilled>
        <div
          class="item-double space-between"
          *ngIf="this.isOverbilledAlreadyUsed"
        >
          <p class="caption-01-semi-bold grey-700">
            El monto total de pagos con factura no debe superar el tope.
          </p>
        </div>
      </ng-template>
      <!-- Agregar factura -->
      <div class="item-form mb-0">
        <qr-button
          id="add-invoice"
          [config]="buttonAddInvoice"
          [isDisabled]="!this.invoiceForm.valid && this.isOverbilledAlreadyUsed"
        ></qr-button>
      </div>
      </ng-container>
    </div>
    <!-- Form END -->
    <div id="tables">
      <!-- Tabla Facturas -->
      <div id="invoices-table-container">
        <p id="title" class="subheading-01-semi-bold grey-700">
          Facturas cargadas
        </p>
        <!-- Tabla INVOICES -->
        <div id="invoices-table">
          <!-- Table Header -->
          <div id="invoices-table-header" class="w-100">
            <app-table-header-new
              class="table-header"
              [tableHeader]="this.tableHeaderInvoices"
              [isCheckboxColumnVisible]="false"
            ></app-table-header-new>
          </div>
          <!-- Table Header END -->
          <!-- Content Invoices -->
          <div
            id="invoices-content"
            *ngIf="this.invoices.length > 0; else noinvoices"
          >
            <div
              class="invoice-item"
              *ngFor="let item of this.invoices; let i = index"
              [ngClass]="{
                'grey-50': i % 2 != 0 && !item.hasError,
                'error-invoice': item.hasError
              }"
            >
              <div class="item-blank"></div>
              <div class="item-circle">
                <div
                  *ngIf="!item.hasError"
                  class="circle"
                  [ngClass]="{
                    'success-50': item.origin == OFFICE_CLIENT,
                    'turquoise-500': item.origin == AGENT_CLIENT,
                    'primary-900': item.origin == AGENT_OFFICE
                  }"
                ></div>
              </div>
              <div class="item-type">
                <p class="paragraph-02-regular grey-800">
                  {{ item.invoiceType || "-" }}
                </p>
              </div>
              <div class="item-number">
                <p class="paragraph-02-regular grey-800">
                  {{ item.number || "-" }}
                </p>
              </div>
              <div class="item-agent">
                <p class="paragraph-02-regular grey-800">
                  {{ item.agent || "-" }}
                </p>
              </div>
              <div class="item-name">
                <p class="paragraph-02-regular grey-800">
                  {{ item.name || "-" }}
                </p>
              </div>
              <div class="item-description">
                <p class="paragraph-02-regular grey-800">
                  {{ item.description || "-" }}
                </p>
              </div>
              <div class="item-total">
                <p class="paragraph-02-regular grey-800">
                  {{ item.amountCurrency == "U$S" ? "U$S " : "$ " }}
                  {{ item.amount | number : "1.0-2" }}
                </p>
              </div>
              <div class="item-iva">
                <p class="paragraph-02-regular grey-800">
                  {{ item.ivaCurrency == "U$S" ? "U$S " : "$ " }}
                  {{ item.iva | number : "1.0-2" }}
                </p>
              </div>
              <div class="item-actions">
                <qr-button
                  id="button-edit"
                  [config]="buttonEdit"
                  (click)="onEdit($event, item.id)"
                  matTooltip="Editar"
                ></qr-button>
                <qr-button
                  [config]="buttonDelete"
                  (click)="onDelete($event, item.id)"
                  matTooltip="Borrar"
                ></qr-button>
              </div>
            </div>
          </div>
          <!-- No invoices -->
          <ng-template #noinvoices>
            <div id="no-invoices">
              <p class="subheading-01-semi-bold grey-500">
                Ninguna factura cargada aún
              </p>
            </div>
          </ng-template>
        </div>
        <!-- Tabla INVOICES END -->
        <div id="invoice-legend">
          <div class="legend-item">
            <div class="circle success-50"></div>
            <p class="paragraph-02-regular grey-800">Oficina al cliente</p>
          </div>
          <div class="legend-item">
            <div class="circle turquoise-500"></div>
            <p class="paragraph-02-regular grey-800">Agente al cliente</p>
          </div>
          <div class="legend-item">
            <div class="circle primary-900"></div>
            <p class="paragraph-02-regular grey-800">Agente a la oficina</p>
          </div>
        </div>
      </div>
      <!-- Tabla Facturas END -->
      <!-- Tabla CAJA PREVISIONAL -->
      <ng-container *ifnodeShow="[NODE_AR, NODE_GLOBAL]">
        <div
          id="caja-previsional-table-container"
          *ngIf="this.cajaPrev.length > 0"
        >
          <div class="flex">
            <qr-icon [name]="'error'" [color]="'grey-700'"></qr-icon>
            <p id="title" class="subheading-01-semi-bold grey-700">
              Caja previsional
            </p>
          </div>
          <!-- Tabla caja-previsional -->
          <div id="caja-previsional-table">
            <!-- Table Header -->
            <div id="caja-previsional-table-header" class="w-100">
              <app-table-header-new
                class="table-header"
                [tableHeader]="this.tableHeaderCajaPrevisional"
                [isCheckboxColumnVisible]="false"
              ></app-table-header-new>
            </div>
            <!-- Table Header END -->
            <!-- Content Invoices -->
            <div id="caja-previsional-content">
              <div
                class="caja-previsional-item"
                *ngFor="let item of this.cajaPrevToShow; let i = index"
                [ngClass]="{ 'grey-50': i % 2 != 0 }"
              >
                <div class="item-type">
                  <div
                    class="circle"
                    [ngClass]="{
                      'success-50': item.origin == 'Oficina',
                      'primary-900': item.origin == 'Agente'
                    }"
                  ></div>
                </div>
                <div class="item-agent">
                  <p class="paragraph-02-regular grey-800">
                    {{
                      item.origin == "Oficina"
                        ? "RE/MAX " + this.loggedUser?.agency_name
                        : item.name || "-"
                    }}
                  </p>
                </div>
                <div class="item-total">
                  <p class="paragraph-02-regular grey-800">
                    {{ item.currency }} {{ item.total | number : "1.0-2" }}
                  </p>
                </div>
                <div class="item-caja-prev">
                  <p class="paragraph-02-regular grey-800">
                    {{ item.caja | number : "1.0-0" }}%
                  </p>
                </div>
                <div class="item-value">
                  <p class="paragraph-02-regular grey-800">
                    {{ item.currency }} {{ item.value | number : "1.0-2" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Tabla INVOICES END -->
        </div>
        <!-- Tabla CAJA PREVISIONAL END -->
      </ng-container>
    </div>
  </div>
</form>
